import React, { Component } from 'react';
//import 'promise-polyfill/src/polyfill'; 
 import { page } from '../js/page';

import Header from './Header';
import Content from './Content';
import Footer from './Footer';
import DocumentMeta from './DocumentMeta';

import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

export default class extends Component {

    componentDidMount() {
        page.init();

        //  Brictoworks GTM
        if(this.props.brictoworksGoogleTagManager){
            TagManager.initialize({
                gtmId: 'GTM-MK4QNS6'
            });
        }

        // 테넌트 GTM
        if(this.props.googleTagManager !== ''){
            TagManager.initialize({
                gtmId: this.props.googleTagManager
            });
        }

        // GA
        if(this.props.ga4TrackingId !== '') {
            ReactGA4.initialize(this.props.ga4TrackingId);

            ReactGA4.send('pageview');
        }

        // GA
        ReactGA.initialize(this.props.googleAnalytics, {
            gaOptions: {
                allowLinker: true
            }
        });

        ReactGA.pageview(window.location.pathname + window.location.search);

        if(this.props.isCrossDomainTrack){
            ReactGA.ga('require', 'linker');
            ReactGA.ga('linker:autoLink', this.props.crossDomainTrack);
        }
    }

    render() {
        return (
            <div>
                <DocumentMeta meta={this.props.data.meta} />
                <Header
                    logoUrl={this.props.data.logoUrl}
                    logoImgUrl={this.props.data.logoImgUrl}
                    tenantName={this.props.data.tenantName}
                />

                <Content
                    content={this.props.data.content}
                    boxStatus={this.props.data.boxStatus}
                    selectTab={this.props.selectTab}
                    selectDonationType={this.props.selectDonationType}
                    payUrl={this.props.payUrl}
                />

                <Footer 
                    tenantCode={this.props.data.tenantCode}
                    content={this.props.data.content.footer} 
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Box.js